import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchLocationText } from "../../../store/formsubmitted";

import { RootState } from "../../../store/rootReducer";


export const LocationSearchBar = () => {
    const dispatch = useDispatch();
    const searchText = useSelector((state: RootState) => state.formSubmittedSlice.searchLocationText);

    return (
        <IonSearchbar
            value={searchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSearchLocationText(value));
            }}
            debounce={700}
            placeholder={"Buscar Instalaciones..."}
            autocomplete="off"
        />
    );
};
